import { render, staticRenderFns } from "./HouseFundsMonth.vue?vue&type=template&id=b610a824&scoped=true"
import script from "./HouseFundsMonth.vue?vue&type=script&lang=js"
export * from "./HouseFundsMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b610a824",
  null
  
)

export default component.exports